/**
 * Created by Ivan on 12.05.2025
 */

const BonusLevelCounter = function () {
    cleverapps.EventEmitter.call(this);

    this.coins = 0;
    this.target = Infinity;
};

BonusLevelCounter.prototype = Object.create(cleverapps.EventEmitter.prototype);
BonusLevelCounter.prototype.constructor = BonusLevelCounter;

BonusLevelCounter.prototype.addCoins = function (amount) {
    this.coins = Math.min(this.target, this.coins + amount);
    this.trigger("onCollect", amount);
};

BonusLevelCounter.prototype.setTarget = function (target) {
    this.target = target;
};

BonusLevelCounter.prototype.getCoins = function () {
    return this.coins;
};
